/**
 * Append next collection page into #product-grid (works with Dawn facets URL state).
 */
(function () {
  document.body.addEventListener('click', function (e) {
    const btn = e.target.closest('[data-joa-load-more]');
    if (!btn || btn.disabled) return;

    const wrap = btn.closest('[data-joa-load-more-wrap]');
    const collectionRoot = btn.closest('.joa-collection');
    const grid = collectionRoot && collectionRoot.querySelector('#product-grid');
    if (!wrap || !grid) return;

    e.preventDefault();

    const sectionId = btn.getAttribute('data-section-id');
    const nextPage = btn.getAttribute('data-next-page');
    if (!sectionId || !nextPage) return;

    btn.disabled = true;

    const url = new URL(window.location.href);
    url.searchParams.set('section_id', sectionId);
    url.searchParams.set('page', nextPage);

    fetch(url.toString())
      .then(function (r) {
        return r.text();
      })
      .then(function (html) {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const fetchedGrid = doc.querySelector('#product-grid');
        const fetchedWrap = doc.querySelector('[data-joa-load-more-wrap]');

        if (fetchedGrid) {
          fetchedGrid.querySelectorAll(':scope > li').forEach(function (li) {
            grid.appendChild(li);
          });
        }

        if (fetchedWrap && wrap.parentNode) {
          wrap.parentNode.replaceChild(fetchedWrap, wrap);
        } else if (wrap.parentNode) {
          wrap.parentNode.removeChild(wrap);
        }
      })
      .catch(function () {
        btn.disabled = false;
      });
  });
})();
